import { useEffect, useState } from 'react';
import API from '../api/axios';
import { io } from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import './GroupChats.css';

const GroupChats = () => {
  const [chats, setChats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadChats();

    const socket = io('https://apicmobot.cryptovoke.com/panel');

    socket.on('new_group_message', (msg) => {
      setChats(prev => {
        const existing = prev.find(c => c.chat_id === msg.chat_id);
        if (existing) {
          return prev.map(c =>
            c.chat_id === msg.chat_id
              ? {
                  ...c,
                  unread_count: c.unread_count + 1,
                  last_message_at: new Date().toISOString(),
                  last_message: msg.message_text
                }
              : c
          );
        }
        return [
          {
            chat_id: msg.chat_id,
            chat_title: msg.chat_title,
            unread_count: 1,
            last_message: msg.message_text,
            last_message_at: new Date().toISOString()
          },
          ...prev
        ];
      });
    });

    socket.on('messages_read', ({ chat_id }) => {
      setChats(prev =>
        prev.map(c => (c.chat_id === chat_id ? { ...c, unread_count: 0 } : c))
      );
    });

    return () => socket.disconnect();
  }, []);

  const loadChats = async () => {
    try {
      const res = await API.get('/group-chats');
      setChats(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="group-chats-page">
      <h1>💬 Group Messages</h1>
      <div className="chat-cards">
        {chats.map(chat => (
          <div
            key={chat.chat_id}
            className="chat-card"
            onClick={() => navigate(`/group-messages/${chat.chat_id}`)}
          >
            <div className="chat-card-header">
              <span className="chat-title">{chat.chat_title}</span>
              {chat.unread_count > 0 && (
                <span className="unread-badge">{chat.unread_count}</span>
              )}
            </div>
            <div className="chat-preview">{chat.last_message || 'Mesaj yok'}</div>
            <div className="chat-time">
              {chat.last_message_at
                ? new Date(chat.last_message_at).toLocaleString()
                : ''}
            </div>
          </div>
        ))}
        {chats.length === 0 && <p className="no-chat">No groups connected yet.</p>}
      </div>
    </div>
  );
};

export default GroupChats;